import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import { PAYMENT_METHOD_CATEGORY_REFUND_LABEL } from 'utils/paymentMethodConstants';
import withFeatureFlags from 'hocs/withFeatureFlags';
import moment from 'moment';
import get from 'lodash/get';
import ShiftDetailRow from './ShiftDetailRow';
import ShiftDetailTotalExpense from './ShiftDetailTotalExpense';
import ShiftDetailTotalIncome from './ShiftDetailTotalIncome';
import ShiftDetailCard from './ShiftDetailCard';
import ShiftDetailCategory from './ShiftDetailCategory';
import ShiftDetailOther from './ShiftDetailOther';
import ShiftDetailEDC from './ShiftDetailEDC';
import ShiftDetailTotal from './ShiftDetailTotal';
import ShiftDetailEWallet from './ShiftDetailEWallet';
import './shiftDetail.css';
import { SHIFT_DETAIL_PAYMENT_METHOD_CATEGORY_CONFIG } from './constants';

class ShiftDetail extends React.Component {
  render() {
    const { shift } = this.props;
    return (
      <div className="col-sm-12 trans-1" id="mk-col-right">
        <div className="mk-col-right-box">
          <div className="scrolled-area">
            <div className="col-right-inner">
              <div className="row">
                <div className="col-sm-12">
                  <div className="label-section">SHIFT DETAILS</div>
                  <div className="col-sm-12">
                    <div className="row list-detail">
                      <ShiftDetailRow
                        label="Name"
                        value={shift.employee_name}
                      />
                      <ShiftDetailRow
                        label="Access"
                        value={shift.outlet_name}
                      />
                      <ShiftDetailRow
                        label="Starting Shift"
                        value={moment
                          .parseZone(shift.created_at)
                          .format('DD MMM YYYY HH:mm')}
                      />
                      <ShiftDetailRow
                        label="Ending Shift"
                        value={
                          shift.ended_at
                            ? moment
                                .parseZone(shift.ended_at)
                                .format('DD MMM YYYY HH:mm')
                            : '-'
                        }
                      />
                      <div className="row">
                        <div className="col-sm-12">
                          <div />
                        </div>
                      </div>
                      <div>
                        <div className="col-sm-12 shift-content">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group col-sm-12 label-section">
                                <label>Cash</label>
                              </div>
                              <div className="col-sm-12 cash_detail no-padding-right">
                                <ShiftDetailRow
                                  label="Starting Cash"
                                  value={currencyFormatter(shift.starting_cash)}
                                />
                                <ShiftDetailRow
                                  label="Cash Sales"
                                  value={currencyFormatter(shift.cash_sales)}
                                />
                                <ShiftDetailRow
                                  label="Cash from Invoice"
                                  value={currencyFormatter(shift.cash_invoice)}
                                />
                                <ShiftDetailRow
                                  label="Cash Refunds"
                                  value={this._printCashRefund(shift)}
                                />
                                <ShiftDetailTotalExpense shift={shift} />
                                <ShiftDetailTotalIncome shift={shift} />
                                <ShiftDetailRow
                                  label="Expected Ending Cash"
                                  value={currencyFormatter(
                                    shift.expected_ending_cash
                                  )}
                                />
                                <ShiftDetailRow
                                  label="Actual Ending Cash"
                                  value={
                                    shift.ended_at
                                      ? currencyFormatter(
                                          shift.actual_ending_cash
                                        )
                                      : '-'
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {this._renderShiftDetailCategories()}
                          <ShiftDetailTotal shift={shift} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mk-col-right-action-box bottom">
          <button
            className="btn btn-primary pull-right"
            onClick={this.props.onClickDoneButton}
          >
            Done
          </button>
        </div>
      </div>
    );
  }

  _renderShiftDetailCategories() {
    const {
      enablePaymentConfiguration,
      shift,
      paymentMethodCategories,
    } = this.props;

    if (enablePaymentConfiguration) {
      return paymentMethodCategories.map(category => {
        const config =
          SHIFT_DETAIL_PAYMENT_METHOD_CATEGORY_CONFIG[category.code] || {};
        const refundValue = get(
          shift,
          ['total_category_refunds', category.code],
          shift[config.refundField]
        );
        const expectedValue = get(
          shift,
          ['total_category_payments', category.code],
          shift[config.expectedField]
        );

        return (
          <ShiftDetailCategory
            key={category.code}
            paymentMethodCategory={category}
            refundLabel={
              PAYMENT_METHOD_CATEGORY_REFUND_LABEL[category.code] ||
              `${category.name} Refunds`
            }
            expectedLabel={`Expected ${category.name} Payment`}
            totalPayments={shift.total_payments}
            refundValue={refundValue}
            expectedValue={expectedValue}
          />
        );
      });
    }

    return (
      <div>
        <ShiftDetailCard shift={shift} />
        <ShiftDetailEWallet shift={shift} />
        <ShiftDetailEDC shift={shift} />
        <ShiftDetailOther shift={shift} />
      </div>
    );
  }

  _printCashRefund = shift => {
    if (shift.cash_refund > 0) {
      return `(${currencyFormatter(shift.cash_refund)})`;
    }
    return currencyFormatter(shift.cash_refund);
  };

  _formatValueShift = (shift, value) => {
    return this._checkEndDate(shift) ? value : '-';
  };

  _checkEndDate = shift => {
    return shift.ended_at !== null;
  };
}

ShiftDetail.propTypes = {
  shift: PropTypes.object,
  paymentMethodCategories: PropTypes.array,
  onClickDoneButton: PropTypes.func,
  enablePaymentConfiguration: PropTypes.bool,
};

const mapFlagsToProps = flags => ({
  enablePaymentConfiguration: flags.enablePaymentConfiguration,
});

export default withFeatureFlags(mapFlagsToProps)(ShiftDetail);
